import * as API from "@/services/API";

export default {
    async getSchoolsFreeTrial(page = 1, perPage = 10) {
        try {
            const response = await API.apiClient.get('/admin-dashboard/schools-free-trial', {
                params: { page, per_page: perPage }
            })
            return response.data
        } catch (error) {
            throw error
        }
    },

    async setSchoolFreeTrial(schoolId, freeTrial, days = null, endsAt = null) {
        try {
            const payload = {
                school_id: schoolId,
                free_trial: freeTrial
            };
            if (days !== null && days !== undefined && days !== '') {
                payload.days = parseInt(days, 10);
            }
            if (endsAt) {
                payload.ends_at = endsAt;
            }
            const response = await API.apiClient.post('/admin-dashboard/set-school-free-trial', payload)
            return response.data
        } catch (error) {
            throw error
        }
    },

    async unsetSchoolFreeTrial(schoolId) {
        try {
            const response = await API.apiClient.post('/admin-dashboard/unset-school-free-trial', {
                school_id: schoolId
            })
            return response.data
        } catch (error) {
            throw error
        }
    }
}
